import { render, staticRenderFns } from "./dashboard-button-secondary.vue?vue&type=template&id=a0168014&"
import script from "./dashboard-button-secondary.vue?vue&type=script&lang=js&"
export * from "./dashboard-button-secondary.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-button-secondary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports